import type {
  ILocationRepository,
  ProjectLocationTabOptions,
  ProjectLocationTabPage,
} from '../repositories/ILocationRepository.js';

interface Deps { locationRepository: ILocationRepository; }

export function createListProjectLocationTabPageUseCase({ locationRepository }: Deps) {
  return async function listProjectLocationTabPage(
    options: ProjectLocationTabOptions,
  ): Promise<ProjectLocationTabPage> {
    return locationRepository.listProjectLocationTabPage(options);
  };
}
